export default __webpack_public_path__ + "3154eea5f4699ad7fa764f19053303a1.svg";